import { render, staticRenderFns } from "./bounty-coupon-alipay.vue?vue&type=template&id=25e48b72&scoped=true&lang=pug&"
import script from "./bounty-coupon-alipay.vue?vue&type=script&lang=js&"
export * from "./bounty-coupon-alipay.vue?vue&type=script&lang=js&"
import style0 from "./bounty-coupon-alipay.vue?vue&type=style&index=0&id=25e48b72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e48b72",
  null
  
)

export default component.exports